/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CompanyList
 */
export interface CompanyList {
  /**
   *
   * @type {string}
   * @memberof CompanyList
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof CompanyList
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof CompanyList
   */
  createdAt?: string
  /**
   *
   * @type {string}
   * @memberof CompanyList
   */
  updatedAt?: string
  /**
   *
   * @type {boolean}
   * @memberof CompanyList
   */
  isPin?: boolean
  /**
   *
   * @type {number}
   * @memberof CompanyList
   */
  countsOfListItem?: number
}

export function CompanyListFromJSON(json: any): CompanyList {
  return CompanyListFromJSONTyped(json, false)
}

export function CompanyListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyList {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
    updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
    isPin: !exists(json, 'is_pin') ? undefined : json['is_pin'],
    countsOfListItem: !exists(json, 'counts_of_list_item') ? undefined : json['counts_of_list_item']
  }
}

export function CompanyListToJSON(value?: CompanyList | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    name: value.name,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    is_pin: value.isPin,
    counts_of_list_item: value.countsOfListItem
  }
}
